import React from 'react'
  import { Box, Typography, Grid, Tab, Tabs, BottomNavigation, BottomNavigationAction, Snackbar, Alert } from '@mui/material'
 import General from './General'
import NewRma from './NewRma'
import PaymentMethod from './PaymentMethod'

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}




  function Configuration() {
   
    const [tabValue, setTabValue] = React.useState(0)
     const [data, setData] = React.useState(null)
   
    const tabChange = (event, newValue) => {
        setTabValue(newValue);
      };

  return (
    <Box sx={{ flexGrow: 1 }}>
    <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
      <Typography variant='h4'>Configuration</Typography>
     
    </Box>
    
    <Grid container spacing={2} columns={24} sx={{ marginTop: '20px' }}>
      <Grid item xs={8}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={tabValue}
          onChange={tabChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1, borderColor: 'divider',
            '& .MuiTab-root': {
              color: '#000',
            },
            '& .MuiTab-root.Mui-selected': {
              color: '#2b3f7a !important'
            }
          }}
        >
          <Tab label="RMA" {...a11yProps(0)} />
          <Tab label=" Create New RMA  " {...a11yProps(1)} />
          <Tab label="Payment Methods" {...a11yProps(2)} />
          
        </Tabs>
      </Grid>
      <Grid item xs={16}>
        <TabPanel value={tabValue} index={0}>
            <General data={data} />
         </TabPanel>
         <TabPanel value={tabValue} index={1}>
         <NewRma data={data} />
         </TabPanel>
         <TabPanel value={tabValue} index={2}>
            <PaymentMethod data={data} />
         </TabPanel>
     
      </Grid>
    </Grid>
  </Box>
 )
}


export default Configuration;